import React from 'react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { LOGO_URL } from '../../data/content';
export function FinalCTA() {
  return <section className="w-full bg-[#0E3B42] px-5 py-14 sm:px-6 sm:py-20" data-id="element-133" data-mp="3msqpo9a1w0ms">
      <div className="mx-auto max-w-2xl" data-id="element-134" data-mp="3rsbnggdhi2xx">
        <h2 className="text-center font-display text-[1.75rem] font-bold leading-[1.12] text-white sm:text-[2.5rem]" data-id="element-135" data-mp="3rrad6e4alkh9">
          Sei pronto a smettere di improvvisare e{' '}
          <em className="font-semibold italic text-[#7FD0DA]" data-id="element-136" data-mp="3huxgr8hd4sit">
            iniziare a seguire un Percorso Clinico?
          </em>
        </h2>

        <div className="mt-6 space-y-4 text-center text-[15px] leading-relaxed text-white/75 sm:text-base" data-id="element-137" data-mp="33x0lqgik4u69">
          <p data-id="element-138" data-mp="38vtz88xugl6f">
            La prossima volta che un paziente ti chiederà se è candidato a un
            GLP-1… non dovrai aprire cinque linee guida, cercare un articolo o
            rimanere con un dubbio davanti allo schermo.
          </p>
          <p className="font-display text-xl font-semibold italic text-white sm:text-2xl" data-id="element-139" data-mp="q7txlda7m2cm">
            Saprai esattamente qual è il prossimo passo.
          </p>
          <p data-id="element-140" data-mp="l7pow9fjmbwy">
            Perché questo è ciò che fa un Percorso Clinico: trasforma
            l’incertezza in decisioni cliniche chiare.
          </p>
        </div>

        <figure className="mt-8" data-id="element-141" data-mp="uzvifnlg11e9">
          <img src={LOGO_URL} alt="Pacchetto completo Percorso Clinico GLP-1 con 6 volumi e 5 bonus" className="mx-auto w-full max-w-sm" width={1080} height={1080} loading="lazy" data-id="element-142" data-mp="79rfzjjzr7ou" />
        </figure>

        <CTAButton className="mt-6" variant="gold" label="Voglio il percorso clinico per €19" subline="Download immediato • Accesso a vita • Garanzia di 7 giorni" data-id="element-143" data-mp="g8cvt6y2w8lx" />

        <div className="mt-10 flex flex-col items-center gap-8 border-t border-white/15 pt-9" data-id="element-144" data-mp="1rrfieysm32qh">
          <Countdown tone="dark" data-id="element-145" data-mp="1msvvav2a7kwj" />
          <ScarcityBar tone="dark" data-id="element-146" data-mp="kdwqupzei9px" />
        </div>
      </div>
    </section>;
}